import APIS from 'src/constants/ApiConfig';
import { IPageResult } from 'src/entity/BaseResult';
import { IDrugStoreInfo, IDrugStoreStatus, ISubDrugStore } from 'src/entity/DrugStoreEntity';
import { IDrugStoreSearch } from 'src/entity/SearchEntity';
import HttpService from 'src/services/HttpService';
import { IFreightTemplate } from '../entity/DrugStoreEntity';
import { IExpressConfig } from 'src/entity/SettingEntity';

/**
 * 默认配药中心状态
 */
export const DrugStoreStatus: IDrugStoreStatus[] = [
  {
    value: true,
    name: '启用',
    key: 'common_status_start',
  },
  {
    value: false,
    name: '停用',
    key: 'common_status_stop',
  },
];

/**
 * 代理商配药中心service
 * @class DrugStoreService
 */
class DrugStoreService {
  /**
   * 代理商配药中心map
   * key： 配药中心id， value： 配药中心object
   * @type {Map<number, IDrugStoreInfo>}
   * @memberof DrugStoreService
   */
  agentDrugStoreMap: Map<number, IDrugStoreInfo> = new Map();

  /**
   * 根据条件查询配药中心列表
   * @memberof DrugStoreService
   */
  getDrugStore = (query: IDrugStoreSearch): Promise<IPageResult<IDrugStoreInfo[]>> => {
    return HttpService.get(APIS.domainUrl(APIS.drugStore), query);
  };

  /**
   * 创建配药中心
   * @memberof DrugStoreService
   */
  createDrugStore = (data: ISubDrugStore): Promise<IDrugStoreInfo> => {
    return HttpService.post(APIS.domainUrl(APIS.drugStore), data);
  };

  /**
   * 更新配药中心
   * @memberof DrugStoreService
   */
  updateDrugStore = (data: ISubDrugStore, id: number): Promise<IDrugStoreInfo> => {
    return HttpService.patch(`${APIS.domainUrl(APIS.drugStore)}${id}/`, data);
  };

  /**
   * 删除配药中心
   * @memberof DrugStoreService
   */
  deleteDrugStore = (id: number): Promise<any> => {
    return HttpService.delete(`${APIS.domainUrl(APIS.drugStore)}${id}/`);
  };

  /**
   * 获取代理商的配药中心
   * @memberof DrugStoreService
   */
  getAgentDrugStore = (): Promise<IDrugStoreInfo[]> => {
    return new Promise(async (resolve, reject) => {
      try {
        const res: IPageResult<IDrugStoreInfo[]> = await HttpService.get(APIS.domainUrl(APIS.drugStore));
        if (!!res) {
          this.initAgentDrugStoreMap(res.results);
        }
        resolve(res.results);
      } catch (err) {
        reject(err);
      }
    });
  };

  /**
   * @description 初始化代理商配药中心map
   */
  initAgentDrugStoreMap = (list: IDrugStoreInfo[]) => {
    this.agentDrugStoreMap.clear();
    for (const obj of list) {
      this.agentDrugStoreMap.set(obj.id, obj);
    }
  };

  /**
   * 根据配药中心id返回名称
   *
   * @param {number} id
   * @returns {string}
   * @memberof DrugStoreService
   */
  getDrugStoreNameById(id: number): string {
    const obj = this.agentDrugStoreMap.get(id);
    if (!!obj) {
      return obj.name;
    }
    return '';
  }

  /**
   * 配药中心运费模板设置
   *
   * @param {IFreightTemplate[]} dataList
   * @returns {Promise<boolean>}
   * @memberof DrugStoreService
   */
  async changeDrugStoreFreightTemplate(dataList: IFreightTemplate[]): Promise<IFreightTemplate[]> {
    const url = `${APIS.domainUrl(APIS.drugStoreSelf)}freight_templates/`;
    return HttpService.put(url, dataList);
  }

  /**
   * 获取快递配置信息
   */
  async fetchExpressConfig(): Promise<IExpressConfig[]> {
    const url = `${APIS.domainApi(APIS.expressConfig)}`;
    return HttpService.get(url);
  }
}

export default new DrugStoreService();



// WEBPACK FOOTER //
// ./src/services/DrugStoreService.ts